//import Moment from "moment";

const getCount = (state) => {
	return state.protocolosEntrega.length;
}

const ultimaAtualizacaoListaProtocoloEntrega = (state) => {
	if (state.ultimaAtualizacaoListaProtocoloEntrega == null) {
		return true;
	}
	else if(!state.protocolosEntrega)
	{
		return true;
	}
	else {
		const d = new Date();
		let hour = d.getHours();
		return (
			state.protocolosEntrega.length == 0 ||
			hour - state.ultimaAtualizacaoListaProtocoloEntrega.getHours() > 0
		);
	}
}

export default {
	getCount,
	ultimaAtualizacaoListaProtocoloEntrega
}